import { netsparkAxios } from 'core/services/HTTPService';
import { IEngagementsTotalItem } from 'pages/Dashboard/Dashboard.models';
import { getProjectAcceptanceUrl } from 'pages/Dashboard/api/apiUrls';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';

const getProjectAcceptance = (signal: AbortSignal, params: TPeriod) => netsparkAxios
  .get<IEngagementsTotalItem[]>(getProjectAcceptanceUrl, { signal, params });

export default getProjectAcceptance;
